import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { ILogin, ILoginResponse, IResetPassword, ISubmitNewPassword, ITwofa } from '@app/api/interfaces/auth.interface';
import { Observable } from 'rxjs';
import { HttpInterceptorParams } from '@app/core/interceptors/classes/http-interceptor-params';
import { AuthMockService } from '@mock/data-services/auth-mock.service';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly MOCK: AuthMockService
  ) {}

  public login(requestData: ILogin): Observable<ILoginResponse> {
    if (this.MOCK.isMockEnabled()) return this.MOCK.login(requestData);

    const url = `${environment.apiBaseUrl}/v1/auth/login`;

    return this.httpClient.post<ILoginResponse>(
      url,
      { ...requestData },
      {
        params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreQueueCancellation: true }),
        withCredentials: true,
      }
    );
  }

  public twofa(requestData: ITwofa): Observable<ILoginResponse> {
    if (this.MOCK.isMockEnabled()) return this.MOCK.twofa(requestData);

    const url = `${environment.apiBaseUrl}/v1/auth/login`;

    return this.httpClient.post<ILoginResponse>(
      url,
      { ...requestData },
      {
        params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreQueueCancellation: true }),
        withCredentials: true,
      }
    );
  }

  public doResetPassword(requestData: IResetPassword): Observable<object> {
    if (this.MOCK.isMockEnabled()) return this.MOCK.doResetPassword(requestData);

    const url = `${environment.apiBaseUrl}/v1/auth/lost-password`;

    return this.httpClient.post<object>(
      url,
      { ...requestData },
      {
        params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreQueueCancellation: true }),
      }
    );
  }

  public doSubmitResetPassword(requestData: ISubmitNewPassword): Observable<object> {
    if (this.MOCK.isMockEnabled()) return this.MOCK.doSubmitResetPassword(requestData);

    const url = `${environment.apiBaseUrl}/v1/auth/reset-password`;

    return this.httpClient.post<object>(
      url,
      { ...requestData },
      {
        params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreQueueCancellation: true }),
      }
    );
  }

  public logout(): Observable<object> {
    if (this.MOCK.isMockEnabled()) return this.MOCK.logout();

    const url = `${environment.apiBaseUrl}/v1/auth/logout`;

    return this.httpClient.post<ILoginResponse>(
      url,
      {},
      {
        params: new HttpInterceptorParams({
          toIgnoreAll: true,
          toIgnoreQueueCancellation: true,
          toCancelPendingRequests: true,
        }),
        withCredentials: true,
      }
    );
  }
}
